import { render } from "./CourseCertificate.vue?vue&type=template&id=88b21fb0&scoped=true"
import script from "./CourseCertificate.vue?vue&type=script&lang=js"
export * from "./CourseCertificate.vue?vue&type=script&lang=js"

import "./CourseCertificate.vue?vue&type=style&index=0&id=88b21fb0&lang=scss&scoped=true"
import "./CourseCertificate.vue?vue&type=style&index=1&id=88b21fb0&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b21fb0"]])

export default __exports__